<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.service.title.list') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          {{ $t('message.admin.mst.service.desc.list.text1') }}
        </div>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="3" class="py-0">
        <mp-button min wide @click="goAdd">{{ $t('message.admin.mst.service.button.toAdd') }}</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          item-key="serviceId"
          :headers="headers"
          :items="view.serviceList"
          locale="jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          disable-pagination
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.serviceId">
                <td>
                  <router-link :to="'/admin/mst/service/detail/' + item.serviceId">
                    {{ item.serviceNameJp }}
                  </router-link>
                </td>
                <td align="center">{{ item.displayOrder }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'
import { AdminMstService } from '@/api'

export default {
  components: {
    MpButton
  },
  data: () => ({
    view: {
      serviceList: []
    },
    form: {
    },
    list: []
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.mst.service.headers.serviceName'), value: 'serviceName', sortable: false, width: '90%' },
        { text: i18n.t('message.admin.mst.service.headers.displayOrder'), align: 'center', value: 'displayOrder', sortable: false, width: '10%' }
      ]
    }
  },
  methods: {
    goAdd () {
      // 追加画面へ遷移
      this.$router.push({ path: '/admin/mst/service/add' })
    }
  },
  created: async function () {
    this.view.serviceList = await AdminMstService.list()
  }
}
</script>

<style scoped>
</style>
